import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';

@Component({
    selector: 'gl-schedule-planner-trip-details-page',
    templateUrl: './schedule-planner-trip-details-page.component.html'
})
export class SchedulePlannerTripDetailsPageComponent extends BaseComponent implements OnInit, OnDestroy {
    tripId: number;

    constructor(private route: ActivatedRoute) {
        super();
    }

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            this.tripId = params['tripId'];
        });
    }
}
